import { getMutationHandler } from '@frontend/duck-tape';
import { showToast } from '@frontend/web-react/utils/toast';
import { addSentryBreadcrumb } from '@frontend/web-utils';

export const handleMutation = getMutationHandler({ addSentryBreadcrumb, showToast });
